import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AxUiService } from '../../services/ax-ui.service';
import {
  WorkEventInvitation,
  WorkEventInvitationDeclinedStatusEnum,
  WorkEventInvitationExamResultEnum,
  WorkEventInvitationsService,
} from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-event-invitation-item',
  templateUrl: './ax-event-invitation-item.component.html',
  styleUrls: ['./ax-event-invitation-item.component.scss'],
})
export class AxEventInvitationItemComponent implements OnInit {
  @Input() eventInvitation: WorkEventInvitation;
  @Input() showLine = true;
  @Output()
  checked: EventEmitter<{ eventInvitation: WorkEventInvitation; checked: boolean }> = new EventEmitter<{
    eventInvitation: WorkEventInvitation;
    checked: boolean;
  }>();
  public eventInvitationDeclinedStatusEnum = WorkEventInvitationDeclinedStatusEnum;
  public eventInvitationExamResultEnum = WorkEventInvitationExamResultEnum;
  public closeSlidingItems = false;

  constructor(
    private readonly axEventInvitationsService: WorkEventInvitationsService,
    private readonly axUiService: AxUiService,
  ) {
  }

  ngOnInit() {
  }

  check(eventInvitation: WorkEventInvitation, event: any) {
    this.checked.emit({ eventInvitation, checked: event.detail.checked });
  }

  public updateExamResult(eventInvitationId: number, eventInvitationExamResultEnum: WorkEventInvitationExamResultEnum, slidingItem: any) {
    this.axEventInvitationsService.eventInvitationsV1ControllerUpdateAsOrganisator({
      id: eventInvitationId,
      body: {
        examResult: eventInvitationExamResultEnum,
      },
    }).subscribe({
      next: () => {
        this.eventInvitation.examResult = eventInvitationExamResultEnum;
      },
      error: async error => {
        await this.axUiService.showError('Diese Aktion kann nur vom Organisator ausgeführt werden.');
      },
      complete: () => {
        slidingItem.close();
      },
    });
  }

  public updateDeclinedStatus(
    eventInvitationId: number,
    eventInvitationDeclinedStatusEnum: WorkEventInvitationDeclinedStatusEnum,
    slidingItem: any,
  ) {
    this.axEventInvitationsService.eventInvitationsV1ControllerUpdateAsOrganisator({
      id: eventInvitationId,
      body: {
        declinedStatus: eventInvitationDeclinedStatusEnum,
      },
    }).subscribe({
      next: () => {
        this.eventInvitation.declinedStatus = eventInvitationDeclinedStatusEnum;
      },
      error: async error => {
        await this.axUiService.showError('Diese Aktion kann nur vom Organisator ausgeführt werden.');
      },
      complete: () => {
        slidingItem.close();
      },
    });
  }
}
